import type { FontListParams } from 'packages/services/fontManagementService';
import type { FontListQuery } from './types';

export const DEFAULT_FONT_LIST_QUERY: FontListQuery = {
    search: '',
    status: 'all',
    sortBy: 'name',
    sortOrder: 'asc',
};

export const isSameFontListQuery = (a: FontListQuery, b: FontListQuery): boolean =>
    a.search === b.search && a.status === b.status && a.sortBy === b.sortBy && a.sortOrder === b.sortOrder;

export const isFilteredFontList = (query: FontListQuery): boolean =>
    query.search.trim() !== '' || query.status !== 'all';

export const fontListParams = ({ search, status, sortBy, sortOrder }: FontListQuery): FontListParams => ({
    query: search.trim() || undefined,
    isActive: status === 'all' ? undefined : status === 'active',
    sortField: sortBy === 'date_created' ? 'CREATED' : 'NAME',
    sortOrder: sortOrder === 'desc' ? 'DESC' : 'ASC',
});

export const REPLACEMENT_CANDIDATES_PARAMS: FontListParams = { isActive: true, sortField: 'NAME', sortOrder: 'ASC' };
